import Vue from "vue"
import Vuex from "vuex"
Vue.use(Vuex)
import userInfo from './modules/userInfo.js'
import getters from './getters.js'
const store = new Vuex.Store({
	modules:{
		userInfo
	},
	getters,
	strict: true
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js